import App from './modules/app'
var app = new App()
